import { PV_DISCLOSURE_ITEM } from "@/types/PresenterModel/PV_DISCLOSURE_ITEM";

export function isDisclosureListItem(
  v: PV_DISCLOSURE_ITEM | null
): v is PV_DISCLOSURE_ITEM {
  return !!(v && v.summaryShort && v.securityName);
}
